import { useAuthContext } from '@aibees/shared/auth';

export function useIsInternalUser() {
  const { user } = useAuthContext();
  return !!user && user.email.includes('@ai-bees.io');
}
